export enum ParticipantSubRole {
  ATTENDEE = "ATTENDEE",
  BUYER = "BUYER",
  EMPLOYEE_IN_TRANSITION = "EMPLOYEE_IN_TRANSITION",
  SELLER = "SELLER",
  ORGANIZATION_ADMIN = "ORGANIZATION_ADMIN",
  SPEAKER = "SPEAKER",
  BADGE_VENDOR = "BADGE_VENDOR",
  BEACON_VENDOR = "BEACON_VENDOR",
  BULK_TICKET_ADMIN = "BULK_TICKET_ADMIN",
  TEAM = "TEAM",
  TEMP = "TEMP",
  TRAVEL_DIRECTOR = "TRAVEL_DIRECTOR",
  VENDOR = "VENDOR"
}

export namespace ParticipantSubRole {
  export function bulkTicketPurchasesAllowed(subRole?: ParticipantSubRole) {
    if (!subRole) {
      return false;
    }
    return ![
      ParticipantSubRole.BULK_TICKET_ADMIN,
      ParticipantSubRole.EMPLOYEE_IN_TRANSITION,
      ParticipantSubRole.ORGANIZATION_ADMIN
    ].includes(subRole);
  }
}

export const AddOrRemoveMeetingRepTagByDefault = [ParticipantSubRole.ATTENDEE, ParticipantSubRole.SELLER];

export default ParticipantSubRole;
